(function() {
  "use strict";

  angular.module("sempraWebapp").constant("skTranslations", {
    MESSAGE:"Správa",
    ERROR_TITLE:"Chyba",
    ERROR_MESSAGE:"Pri vykonávaní operácie došlo k chybe.",
    ERROR_LOGIN:"Počas prihlasovania došlo k chybe. E-mailová adresa alebo heslo nie sú platné",
    ERROR_LOGIN_ROLE:"Úloha pre aktuálnu značku aplikácie nie je platná",
    OK:"OK",
    CANCEL:"Zrušiť",
    YES:"Áno",
    NO:"Nie",
    FROM:"Od",
    TO:"Do",
    DELETE:"Odstrániť",
    SIGN_OUT:"Odhlásiť sa",
    NAME:"Názov",
    DATE:"Dátum",
    PIECES:"kusy",
    HOURS:"Hodiny",
    DAYS:"Dni",
    MONTH:"Mesiac",
    MONTHS:"Mesiace",
    YEAR:"Rok",
    BOX:"Box",
    SEARCH:"Vyhľadávanie",
    ALL_USERS:"Všetci používatelia",
    ARE_YOU_SURE:"Ste si istý?",
    BACK:"Späť",
    AMOUNT:"Suma",
    DESCRIPTION:"Popis",
    FORGOT_PASSWORD_ERROR_MSG:"Niečo sa pokazilo. Skontrolujte prosím svoju e-mailovú adresu a skúste to znova",
    REQUIRED_FIELD:"Pole je povinné",
    LOGOUT_TITLE:"Určite sa chcete odhlásiť?",
    LOGOUT_MSG:"Všetky neuložené údaje sa stratia",
    ACTIVATION_ACCOUNT:"Úspešne ste aktivovali svoj účet",
    UNKNOWN_ERRROR_NOTIFICATION:"Vyskytla sa neznáma chyba",
    CONTINUE:"Pokračovať",
    DATA_NOT_AVAILABLE:"Údaje nie sú k dispozícii",
    SELECT:"Vyberte",
    SELECT_CURRENCY:"Vyberte menu",
    UPLOAD:"Nahrať",
    PHONE:"Telefón",
    WEBSITE:"Webová stránka",
    WORKING_HOURS:"Pracovný čas",
    INSERT:"Vložte",
    TEXT:"Text",
    CREATED:"Vytvorené",
    VALID_UNTIL:"Platnosť do",
    SAVE:"Uložiť",
    TOKENS:"Žetóny",
    DELETE_COMPANY_HISTORY:"Vymazať históriu spoločnosti?",
    DELETE_COMPANY_HISTORY_INFO:"Táto akcia odstráni všetky údaje o správach pre vašu spoločnosť. Táto akcia sa nedá vrátiť späť.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Ste si istý, že chcete natrvalo odstrániť všetky údaje správ?",
    DELETE_COMPANY_HISTORY_MESSAGE:"VAROVANIE: Po stlačení tohto tlačidla sa všetky transakcie vašej umývačky natrvalo vymažú! Tieto údaje nie je možné po vymazaní obnoviť.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Ste si istí, že chcete natrvalo vymazať všetky údaje o transakciách?",
    HISTORY_SUCCESSFULY_DELETED:"História bola úspešne odstránená",
    HELP:"Pomoc",
    VALUE:"Hodnota",
    ACTIVATING_ACCOUNT_ERROR:"Pri aktivácii vášho konta R2W došlo k problému.Skúste to prosím znova a ak problém pretrváva, kontaktujte našu podporu na adrese support@ready2wash.com.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Welcome to Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Vitajte v spoločnosti R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Na aktiváciu konta R2W zadajte a potvrďte svoje nové heslo. Po úspešnom prihlásení budete automaticky prihlásení do aplikácie",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Nastavenia používateľa môžete neskôr zmeniť v aplikácii",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Autoumyváreň Kärcher",
    RESET_PASSWORD_WELCOME_MSG:"Autoumyváreň R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Zadajte nové heslo a potvrďte ho, aby ste mohli obnoviť staré heslo. Po úspešnej zmene hesla sa automaticky prihlásite do aplikácie.",
    RESET_PASSWORD_WELCOME_MSG_3:"Nastavenia používateľa môžete neskôr zmeniť v aplikácii",
    ENTER_NEW_PASSWORD:"Zadajte nové heslo",
    REPEAT_NEW_PASSWORD:"Opakovanie nového hesla",
    PASSWORD_MIN_LENGTH:"Heslo musí mať aspoň 8 znakov",
    PASSWORD_MAX_LENGHT:"Heslo musí mať menej ako 32 znakov",
    PASSWORD_PATTERN:"Heslo musí obsahovať aspoň jedno veľké a jedno malé písmeno.",
    PASSWORD_MATCH:"Heslá sa nezhodujú",
    ACTIVATE:"Aktivujte",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Úspešne ste odoslali žiadosť. Prosím, skontrolujte si e-mail pre potvrdzujúcu správu",
    VALIDATION_REQUIRED:"Povinné pole",
    VALIDATION_EMAIL:"Neplatná e-mailová adresa",
    VALIDATION_INTEGER_NUMBER:"Zadajte celočíselnú hodnotu",
    VALIDATION_HOURS_VALUE:"Hodnota musí byť v rozmedzí 0-23",
    VALIDATION_MINUTES_VALUE:"Hodnota musí byť v rozmedzí 0-59",
    VALIDATION_NOT_A_DATE:"Hodnota nie je dátum",
    VALIDATION_FROM:"Od dátumu, ktorý je väčší ako do",
    VALIDATION_TO:"K dátumu menšiemu ako z",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Tento záznam už existuje v databáze",
    PASSWORD_VALIDATION_PATTERN_NEW:"Musí tam byť aspoň jedna číslica, jedno malé a jedno veľké písmeno. Biele medzery nie sú povolené",
    VALIDATION_PERCENT_VALUE:"Hodnota musí byť v rozsahu 1-999",
    NUMBERS_ONLY_100:"Počítanie do 100",
    NUMBERS_ONLY_1000:"Počítanie do 1000",
    POSITIVE_NUMBERS_ONLY:"Počítanie iba s číslom",
    GRID_PAGER_PAGE:"Strana",
    GRID_PAGER_ROWS_PER_PAGE:"Riadky na stránku",
    GRID_PAGER_PAGE_OF:"z",
    BREAD_CRUMBS_HOME:"Domov",
    BREAD_CRUMBS_DASHBOARD_TECH:"Technológia prístrojovej dosky",
    BREAD_CRUMBS_DETAILS:"Podrobnosti",
    BREAD_CRUMBS_SETTINGS:"Nastavenia",
    BREAD_CRUMBS_WORKING_HOURS:"Working hours",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Správa o celkovej sume peňazí za dni",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Správa o priemerných peniazoch za hodinu",
    BREAD_CRUMBS_NEW_USER_GROUP:"Vytvorenie skupiny používateľov",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Upraviť skupinu používateľov",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Vytvorenie šablóny kampane",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Úprava šablóny kampane",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Vytvorenie kampane",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Úprava kampane",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Pravidelné zhrnutie",
    LOGIN:"Prihlásiť sa",
    EMAIL:"E-mail",
    PASSWORD:"Heslo",
    LANGUAGE:"Jazyk",
    FORGOT_PASSWORD:"Zabudli ste heslo?",
    SUBMIT:"Odoslať",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Počet čakajúcich alarmov:",
    HEADER_VIEW_ALL_ALARMS:"Zobraziť všetky alarmy...",
    HEADER_MY_ACCOUNT:"Môj účet",
    HEADER_ACCOUNT_MANAGEMENT:"Správa účtu",
    ACCOUNT_ALREADY_EXIST:"E-mailová adresa sa už používa",
    NEWSLETTER_CONFIRMATION:"Odoslanie e-mailového oznámenia o stave alarmu",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Prehľad denných financií",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Technológia prístrojovej dosky",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Prístrojová doska",
    ASIDE_MENU_ALARMS:"Správy",
    ASIDE_MENU_FACILITIES:"Zariadenia",
    ASIDE_MENU_REPORTS:"Reporty",
    ASIDE_MENU_REPORT:"Vybraný report",
    ASIDE_MENU_LOYALTY:"Lojalita",
    ASIDE_MENU_USER_GROUPS:"Skupiny používateľov",
    ASIDE_MENU_PERIODIC_SUMMARY:"Pravidelné zhrnutie",
    ASIDE_MENU_MANAGING_TOKENS:"Správa žetónov",
    ASIDE_MENU_NEWS:"Novinky",
    DAILY_FINANCES_TOTAL_MONEY:"Celková suma peňazí",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Celková suma pre všetky zariadenia",
    DAILY_FINANCES_TOTAL_COINS:"Celkovo použitých kovových žetónov",
    DAILY_FINANCES_DOWNLOAD_CSV:"Stiahnuť CSV",
    DAILY_FINANCES_ONLINE:"R2W (online)",
    DAILY_FINANCES_OFFLINE:"Hotovosť",
    DAILY_FINANCES_CHANGER:"Hotovosť v meničke",
    DAILY_FINANCES_COINS:"Žetóny/Eurokey",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Typ reportu",
    REPORTS_CHOOSE_FACILITY:"Vyberte si zariadenie",
    REPORTS_PERIOD_1:"Obdobie 1 -",
    REPORTS_PERIOD_2:"Obdobie 2 -",
    MONEY_BY_DATE_REPORT:"Celkový príjem podľa dátumu",
    R2W_BY_DATE_REPORT:"Celkový príjem zo žetónov R2W podľa dátumu",
    COINS_BY_DATE_REPORT:"Celkový počet použitých žetónov podľa dátumu",
    AVG_MONEY_BY_HOUR_REPORT:"Priemerný hodinový príjem",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Priemerný príjem podľa dňa v týždni",
    AVG_MONEY_BY_BOX_REPORT:"Výdavky podľa umývacej stanice",
    COMPARE_PERIODS_REPORT:"Porovnávacia správa zariadenia",
    TOTAL_USERS_BY_GROUP:"Celkový počet návštev aplikácie R2W za deň",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"používatelia",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"návštevy",
    VISITS_COUNT_REPORT:"Počet používateľov aplikácie R2W na jednu návštevu",
    LOYALTY_PER_DAY_REPORT:"Počet miestnych žetónov využitých za deň",
    LOYALTY_PER_PAYMENT_METHOD:"Miestne žetóny priradené k platobnej metóde",
    VISITS:"Návštevy",
    VISIT:"Návšteva",
    TOTAL_SPENT_MONEY:"Celkový príjem",
    MONEY:"Peniaze",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Celkový príjem za obdobie",
    DOWNLOAD_CSV:"Stiahnuť CSV",
    TOTAL_SPENT_COINS:"Celkový počet použitých žetónov",
    TOTAL_USERS:"Celkový počet používateľov",
    TOTAL_CREDIT_GIVEN:"Celkový počet použitých miestnych virtuálnych žetónov",
    EUROKEY_BY_DATE_REPORT:"Celkové platby Eurokey podľa dátumu",
    TOTAL_SPENT_EUROKEY:"Celkové výdavky",
    SELECT_TYPE_OF_REPORT:"Musíte vybrať typ správy",
    NUMBER_OF_VISITS_TITLE:"Počet návštev",
    NUMBER_OF_USERS_TITLE:"Počet používateľov",
    PIECES_TITLE:"Kúsky",
    TOTAL_VISITS:"Celkový počet návštev",
    TOKENS_TITLE:"žetóny",
    SEARCH_USERS_NO_RESULTS:"Nenašli sa žiadni používatelia pre daný hľadaný výraz",
    SEARCH_USERS:"Vyhľadávanie používateľov",
    SEARCH_TELEPHONES:"Vyhľadávanie používateľov podľa telefónneho čísla.",
    ADD_USER_TO_GROUP:"Pridanie používateľa do skupiny",
    REMOVE_USER_FROM_GROUP:"Odstránenie používateľa zo skupiny",
    USER_GROUP_NAME_REQUIRED:"Vyžaduje sa názov skupiny používateľov",
    USER_GROUP_NAME:"Názov skupiny používateľov",
    USER_GROUPS_OVERVIEW:"Prehľad skupín používateľov",
    USER_COUNT:"Počet používateľov",
    NEW_USER_GROUP:"Vytvorenie novej skupiny používateľov",
    DELETE_USER_GROUP:"Odstránenie skupiny používateľov",
    UPDATE_USER_GROUP:"Upraviť skupinu používateľov",
    DELETE_USER_GROUP_ERROR:"Pri odstraňovaní vybranej skupiny používateľov došlo k chybe. Skúste to prosím znova alebo kontaktujte podporu...",
    CONFIRM_DELETE_USER_GROUP:"Ste si istí, že chcete odstrániť vybranú skupinu používateľov?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Vernostné akcie, ku ktorým bola vymazaná skupina priradená, sa už nebudú uplatňovať.",
    GROUP_NAME_MAX_LENGTH:"Názov skupiny musí mať menej ako 255 znakov",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Používateľ je už v tejto skupine",
    MISSING_USER:"Chýbajúci používateľ",
    USER_NOT_ON_LIST:"Používateľ nie je v zozname aktívnych používateľov. Skontrolujte, či je e-mailová adresa platná, a skúste to znova.",
    UPLOAD_USER_GROUP:"Nahrávanie zoznamu skupín používateľov zo súboru *.csv",
    UKNOWN_USERS:"Zoznam neznámych používateľov",
    CAMPAIGN_TEMPLATE_RULE:"Pravidlo šablóny",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Pri pokuse o odstránenie šablóny kampane došlo k chybe. Skúste to prosím znova alebo kontaktujte podporu...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Určite chcete odstrániť vybranú šablónu kampane",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Určite chcete odstrániť vybranú šablónu kampane",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Prehľad šablón kampaní",
    DELETE_CAMPAIGN_TEMPLATE:"Odstránenie šablóny kampane",
    UPDATE_CAMPAIGN_TEMPLATE:"Úprava šablóny kampane",
    CREATE_CAMPAIGN_TEMPLATE:"Vytvorenie novej šablóny kampane",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Vyžaduje sa názov šablóny kampane",
    CAMPAIGN_TEMPLATE_NAME:"Názov šablóny kampane",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Povinné pole",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"dať %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"predĺženie času",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Najskôr vyberte typ. Umývacie boxy alebo malé stroje.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Odstránenie pravidla šablóny",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"Do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"hodiny",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minúty",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nové pravidlo podľa počtu návštev",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nové pravidlo podľa množstva použitých žetónov",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nové pravidlo podľa dňa v týždni",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Pridanie nového pravidla šablóny",
    CAMPAIGN_TEMPLATE_RULE_1:"Každý",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Každý",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetóny minulé za menej ako",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"návštevy za menej ako",
    CAMPAIGN_TEMPLATE_RULE_3:"dni",
    CAMPAIGN_TEMPLATE_RULE_4:"žetóny",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Zoznam pravidiel je prázdny.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Dátum nemôže byť v minulosti",
    DELETE_CAMPAIGN_ERROR:"Pri pokuse o odstránenie kampane došlo k chybe. Skúste to prosím znova alebo kontaktujte podporu...",
    CONFIRM_DELETE_CAMPAIGN:"Ste si istí, že chcete odstrániť vybranú kampaň?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"Ste si istí, že chcete odstrániť vybraný text kampane?",
    CAMPAIGNS_OVERVIEW:"Prehľad kampaní",
    DELETE_CAMPAIGN:"Odstránenie kampane",
    UPDATE_CAMPAIGN:"Úprava kampane",
    CREATE_CAMPAIGN:"Vytvorenie novej kampane",
    CAMPAIGN_ACTIVE:"Aktívne",
    CAMPAIGN_TEMPLATE:"Šablóna",
    CAMPAIGN_GROUPS:"Skupiny",
    CAMPAIGN_ALL_USERS:"Všetci používatelia",
    CAMPAIGN_NAME:"Názov kampane",
    CAMPAIGN_NAME_REQUIRED:"Požadované",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Počet používateľov blízko limitu za deň",
    MESSAGE_TO_USERS:"Správa pre filtrovaných používateľov",
    SEND_MESSAGE:"Odoslať správu",
    THRESHOLD:"limit",
    TYPE:"Typ",
    TOTAL_MONEY_SPENT:"Celková suma vynaložená na kampaň",
    NUMBER_OF_VISITS:"Počet návštev v kampani",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Správa musí mať aspoň 10 znakov",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Správa musí mať menej ako 350 znakov",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Vyžaduje sa text správy",
    TECHNOLOGY:"Technológia",
    TAP_WATER:"Voda z vodovodu",
    REVERSE_OSMOSIS:"Reverzná osmóza",
    SOFTENED_WATER:"Zmäkčená voda",
    DOSER:"Doser",
    STATUS:"Stav",
    LAST_SYNCHRONIZATION:"Posledná synchronizácia",
    NO_OF_CURRENT_ALARMS:"Počet aktuálnych alarmov",
    NO_OF_CURRENT_WARNINGS:"Počet aktuálnych varovaní",
    WEATHER:"Počasie",
    BOXES_WORK_HOURS_COUNTERS:"Pracovný čas boxov",
    BOX_TOTAL_HOURS:"Celkový počet pracovných hodín",
    BOX_SERVICE_HOURS:"Celkový počet pracovných hodín (služba)",
    BOX_COUNTER_HOURS:"hodiny",
    ALARMS_AND_WARNINGS:"Alarmy a varovania",
    FILTER_AND_BOILER:"Filter a kotol",
    FILTER_TOTAL_DAYS:"Pracovné dni filtra",
    BOILER_TOTAL_DAYS:"Pracovné dni kotla",
    DAYS_UNIT:"dni",
    SOFTENER:"Zmäkčovač",
    MANUAL_COLD_DRAIN:"Manuálne vypúšťanie studenej vody",
    EL_COLD:"El. studený",
    DRAIN:"odtok",
    TAP:"kohútik",
    WASTE:"Odpad",
    OSMOSIS:"osmóza",
    DEMI_WATER:"Demi voda",
    EL_RINSE:"El. m. rinse",
    BOILER:"Kotol",
    EL_WAX:"El. m. vosk",
    FLOOR_HEATING:"Podlahové vykurovanie",
    DOSER_TANK:"Nádrž dávkovača",
    EL_WASH:"El. m. wash",
    DETERGENT:"Čistiaci prostriedok",
    VIBRATOR:"Vibrátor",
    UPDATE_FACILITY_SETTINGS:"Aktualizácia nastavení",
    GENERAL_SETTINGS:"Všeobecné nastavenia",
    LIGHTS:"Svetlá",
    GROUPS:"Skupiny",
    ANTI_FREEZE:"Ochrana proti zamrznutiu",
    AUTO:"Auto",
    MANUAL:"Manuál",
    ON:"Zapnuté",
    OFF:"Vypnuté",
    TEMPERATURE:"Teplota",
    UPDATE_DEVICE:"Aktualizácia nastavení zariadenia",
    BOX_CLEAN_HOURS:"Počítadlá na čistenie boxov (v hodinách)",
    GROUP_COUNTERS:"Počítadlá skupín",
    RESET:"Obnovenie",
    CASH_COUNT:"Počítadlo mincí",
    COINS_COUNT:"Počítadlo žetónov",
    EUROKEY_COUNT:"Počítadlo Eurokey",
    DOSER_WORK:"Pracovný čas dávkovača (sek.)",
    DOSER_PAUSE:"Čas pauzy dávkovača (s)",
    DELAY_BFV:"Oneskorenie BFV (ms)",
    DELAY_6M1:"Oneskorenie 6M1 (ms)",
    DELAY_LPS:"Oneskorenie LPS (ms)",
    RESET_CASH_COUNT_ALL:"Resetovanie všetkých počítadiel mincí",
    RESET_COINS_COUNT_ALL:"Resetovanie všetkých počítadiel žetónov",
    RESET_EUROKEY_COUNT_ALL:"Resetovanie všetkých počítadiel Eurokey",
    FACILITY_DETAILS:"Podrobnosti o zariadení",
    FACILITY_NAME:"Názov zariadenia",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Úspešne ste nahrali obrázok",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Úspešne ste aktualizovali údaje",
    CONNECTED:"Pripojené",
    DISCONNECTED:"Odpojené",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Filter správ",
    FACILITY:"Zariadenie",
    APPLY:"Aplikovať",
    TIME:"Čas",
    LOCATION:"Umiestnenie",
    ACKNOWLEDGED:"Potvrdené",
    FILTERED_MESSAGES:"Filtrované správy",
    ACK:"Potvrdené",
    NOT_ACK:"Neuznané",
    ALL:"Všetky",
    ALL_FACILITIES:"Všetky zariadenia",
    ENTER_DATE_PLACEHOLDER:"Zadajte dátum",
    OP_NESTANAK_NAPONA:"Chýbajúce napätie na indikátore fázy 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Vypadol istič vysokotlakového čerpadla",
    OP_UPR_NAPON_24VAC_GRE:"Chýba 24 VAC - istič 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Nádrž na čerstvú vodu je prázdna",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Vypadol istič sieťového vodného čerpadla",
    OP_MIN_NIVO_OMEKS_VODE:"Nádrž na zmäkčenú vodu je prázdna",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Vypadol istič čerpadla zmäkčenej vody",
    OP_MIN_NIVO_DEMIN_VODE:"Nádrž na vodu s osmózou je prázdna",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Vypadol istič vodného čerpadla osmózy",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Vypadol istič výrobného čerpadla osmózy",
    OP_BOJLER_GRESKA_MZS:"Chyba ohrievača vody",
    OP_CRPKA_PRASKA_GRE_MZS:"Vypadol istič čerpadla teplej vody",
    OP_DOZATOR_PRASKA_GRE_MZS:"Vypadol istič motora dávkovania prášku",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Práškový dávkovací vibračný istič klesol",
    OP_MIN_PRASAK_TON_ALARM:"Prázdna zmiešavacia nádrž na prášok",
    OP_USIS_KOV_TURBINA_GRESKA:"Vypadol istič vysávania mincí",
    OP_FILTER_VODE_ZACEPLJEN:"Zablokovaný vodný filter",
    OP_VISKTL_RESET_SATI_RADA:"Servis vysokotlakových čerpadiel",
    OPW_VISKTL_RESET_SATI_RADA:"Servis vysokotlakových čerpadiel",
    OP_FILTER_DANI_RADA:"Porucha vodného filtra",
    OP_BOJLER_DANI_RADA:"Porucha ohrievača vody",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm vysokotlakového čerpadla",
    OPW_ALARM_FILTER_SERVIS:"Servisný alarm filtra",
    OPW_ALARM_BOJLER_SERVIS:"Servisný alarm kotla",
    HAS_MEMBERS:"Vybraná skupina má členov a nemožno ju odstrániť. Členov je potrebné najprv odstrániť.",
    PERIODIC_SUMMARY_FOR:"Pravidelná súhrnná správa pre",
    PERIODIC_SUMMARY_REPORTS:"Pravidelné súhrnné správy",
    DATE_RANGE:"Rozsah dátumov",
    FINANCIAL_REPORT:"Finančná správa",
    GROSS_INCOME:"Hrubý príjem",
    GROSS_INCOME_SUM:"Celková suma hrubého príjmu",
    COMMISSION_FEE:"Poplatok za províziu",
    NET_INCOME:"Čistý príjem (na fakturáciu)",
    COMMISSION_FEE_DETAILS:"Provízia zahŕňa poplatok banky / PayPal alebo poskytovateľov služieb SMS.",
    LOYALTY_CREDITS_REPORT:"Správa o miestnych žetónoch",
    LOYALTY_GIVEN:"Dané lokálne žetóny",
    LOYALTY_USED:"Použité miestne žetóny",
    LOYALTY_SOLD:"Načítané miestne žetóny",
    LOYALTY_TOTAL:"Celkom",
    LOYALTY_CURRENT_MONTH:"Aktuálny mesiac",
    SOMETHING_WENT_WRONG:"Niečo sa pokazilo",
    MISSING_PAGE:"Prepáčte. Túto stránku sa nám nepodarilo nájsť",
    TRY_AGAIN:"Skúste to znova",
    DEFAULT_ERROR_NAME:"Vyskytla sa neznáma chyba",
    DEFAULT_ERROR_DESCRIPTION:"Skúste to prosím znova",
    MY_ACCOUNT_DETAILS:"Podrobnosti o mojom účte",
    SAVE_CHANGES:"Uloženie zmien",
    USERNAME:"Používateľské meno",
    FIRST_NAME:"Krstné meno",
    LAST_NAME:"Priezvisko",
    USER_ROLE:"Úloha používateľa",
    OLD_PASSWORD:"Staré heslo",
    NEW_PASSWORD:"Nové heslo",
    OLD_PASSWORD_REQUIRED:"Vyžaduje sa staré heslo",
    NEW_PASSWORD_REQUIRED:"Vyžaduje sa nové heslo",
    NEW_PASSWORD_REPEAT:"Vyžaduje sa opakovanie nového hesla",
    NEW_PASSWORD_NOT_MATCH:"Staré a nové heslo sa nezhodujú",
    PASSWORD_DIFFERENT_VALIDATION:"Nové heslo sa musí líšiť od starého",
    PASSWORD_MIN_CHAR:"Vaše heslo musí mať aspoň 8 znakov.",
    PASSWORD_MAX_CHAR:"Vaše heslo musí mať maximálne 32 znakov.",
    PASSWORD_PATTERN_VALIDATION:"Heslo musí obsahovať aspoň jedno číslo",
    ACCOUNT_MANAGEMENT:"Správa účtov",
    NOT_ACTIVE:"Nie je aktívny",
    ASSIGN_ROLE:"Priradenie úlohy",
    UPDATE:"Aktualizácia",
    ADD_NEW_ACCOUNT:"Pridať nové konto",
    EMAIL_REQUIRED:"Vyžaduje sa e-mailová adresa",
    EMAIL_NOT_VALID:"E-mailová adresa nie je platná",
    ADD_NEW_USER_TEXT:"Na zadanú e-mailovú adresu bude odoslaný e-mail s aktivačným prepojením.",
    UPDATE_USER_NOTIFICATION:"Úspešne ste aktualizovali svoje údaje",
    CHANGED_PASSWORD_NOTIFICATION:"Úspešne ste zmenili heslo",
    UPDATE_USER_GROUP_NOTIFICATION:"Úspešne ste aktualizovali názov skupiny používateľov",
    CREATE_USER_GROUP_NOTIFICATION:"Úspešne ste vytvorili skupinu",
    DETELE_USER_GROUP_NOTIFICATION:"Úspešne ste odstránili skupinu",
    EMPTY_GROUP_LIST_MSG:"Nie sú vytvorené žiadne skupiny. Začnite vytvorením jednej z nich",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Úspešne ste odstránili používateľa zo skupiny",
    ADD_USER_TO_GROUP_NOTIFICATION:"Úspešne ste pridali používateľa do skupiny",
    ADD_USER_NOTIFICATION:"Úspešne ste pridali nového používateľa",
    DELETE_USER_NOTIFICATION:"Úspešne ste odstránili používateľa",
    RESEND_USER_VERIFICATION_EMAIL:"Úspešne ste opätovne odoslali overovací e-mail",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Ak chcete vytvoriť skupinu používateľov",
    DELETE_USER:"Odstránenie používateľa",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Ste si istí, že chcete odstrániť používateľa zo skupiny používateľov?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Vážený používateľ R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravidlo vernosti na počet návštev",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravidlo vernostného programu na množstvo využizývh žetónov",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravidlo vernosti na deň v týždni",
    REMOVE_CAMPAIGN_RULE_TITLE:"Odstránenie pravidiel kampane",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Ste si istí, že chcete odstrániť pravidlo kampane?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Úspešne ste vytvorili novú kampaň",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Úspešne ste aktivovali kampaň",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Neexistujú žiadne vytvorené kampane. Začnite vytvorením jednej",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Úspešne ste odoslali správu",
    COMPANY_ACCOUNTS:"Účty spoločnosti",
    BUSSINESS_INVOICES_LIST:"Moje faktúry B2B",
    LOCALE_TOKEN:"Miestny žetón",
    R2W:"Globálny žetón",
    START_MONTH:"Začiatok mesiaca",
    END_MONTH:"Koniec mesiaca",
    TOKEN_TYPE:"Typ žetónu",
    TOKEN_NUMBER:"Číslo žetónu",
    NOTHING_TO_DISPLAY:"* Nič na zobrazenie",
    CREATE_INVOICE:"Vytvoriť faktúru",
    INVOICE:"Faktúra",
    INVOICES:"Faktúry",
    EDIT_INVOICE:"Upraviť faktúru",
    UPDATE_INVOICE_NOTIFICATION:"Úspešne ste aktualizovali faktúru do stavu čakajúce na vybavenie",
    CURRENT_CHARGES:"Poplatky za súčastné obdobie",
    PAYMENTS_ON_HOLD:"Faktúry v procese spracovania",
    FOR_INVOICING:"Na fakturáciu",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Chystáte sa zrušiť faktúru",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Ste si istí, že chcete zrušiť túto faktúru ?",
    INVOICING_NOTIFICATION_HEADER:"Chystáte sa fakturovať",
    INVOICING_NOTIFICATION_TEXT:"Ste si istí, že chcete poslať faktúru?",
    SENT_INVOICE_NOTIFICATION:"Úspešne ste odoslali faktúru",
    CANCELED_INVOICE_NOTIFICATION:"Úspešne ste zrušili faktúru",
    INVOICE_DESCRIPTION_TEXT:"Faktúra za",
    INVOICE_STATE:"Stav faktúry",
    INVOICE_NUMBER:"Číslo faktúry",
    INVOICE_TOTAL:"Celkom",
    SELECT_YEAR:"Vyberte rok",
    DOWNLOAD:"Stiahnuť PDF",
    INVOICE_NUMBER_HEADER:"Chystáte sa odoslať faktúru s číslom",
    INVOICE_PAYMENT_CONFIRMATION:"Chystáte sa potvrdiť platbu za",
    INSERT_INVOICE_NUMBER:"Vložte číslo faktúry",
    INVOICED_WARNING:"E-mail nebol odoslaný. Počkajte prosím...",
    SEND_INVOICE:"Odoslať",
    INVOICE_ALL:"Všetky",
    INVOICE_FROM_R2W:"Od spoločnosti R2W",
    INVOICE_TO_R2W:"Na R2W",
    PAYMENT_REQUEST:"Žiadosť o platbu",
    PAYMENT_REQUEST_STATE:"Stav žiadosti o platbu",
    PAYMENT_REQUEST_NUMBER:"Číslo žiadosti o platbu",
    FOR_PAYMENT_REQUEST:"Pre žiadosti o platbu",
    PAYMENT_REQUEST_ON_HOLD:"Žiadosti o platbu v procese",
    DOWNLOAD_INVOICE:"Stiahnite si faktúru",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite pre možnosti stiahnutia",
    B2B_SPEC:"Špecifikácia B2B",
    B2C_SPEC:"Špecifikácia B2C",
    DOWNLOAD_PAYMENT_REQUEST:"Stiahnuť žiadosť o platbu",
    LOYALTY_PREVIEW:"Ukážka vernostného programu",
    ACTIVATED:"Aktivované",
    RUNNING:"Prebieha",
    NOT_ACTIVATED:"Nie je aktivovaný",
    FINISHED:"Dokončené",
    DEPRECATED:"Vyradené",
    UPCOMING:"Nadchádzajúce",
    NONE:"Individuálne",
    STARTED:"Začal",
    ENDS:"Končí",
    DEDICATED:"Venované",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Chystáte sa aktivovať",
    CAMPAIGN:"Kampaň",
    SEND_MESSAGE_NOTIFICATION:"Chystáte sa odoslať správu vybraným skupinám používateľov",
    DIVISIBLE_TO_NUMBER:"Číslo by malo byť deliteľné s",
    BRIDGE_PLC:"Mostík - PLC",
    DEVICE_TYPE:"Typ zariadenia",
    LISTENER:"Malé stroje",
    BRIDGE:"Umývacie boxy",
    WASH_BOXES:"Umývacie boxy",
    VACUUMS:"Vysávače",
    SAVE_NEWS:"Uložiť novinky",
    CREATE_NEW_NEWS:"Vytvorenie novej správy",
    HISTORY_OF_ALL_NEWS:"História všetkých správ",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Zadajte názov zariadenia",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Pridanie ďalšieho zariadenia",
    NEWS_TEXT:"Text správy",
    NEWS_TITLE:"Názov správy",
    DELETE_NEWS_CONFIRMATION:"Chystáte sa vymazať správy",
    NEWS_DELETE_NOTIFICATION:"Úspešne ste vymazali správy",
    NEWS_SAVE_NOTIFICATION:"Úspešne ste uložili správy",
    NEWS_CREATION_DATE:"Dátum vytvorenia",
    NO_TITLE:"Žiadny názov",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Text správy musí mať menej ako 255 znakov",
    NEWS_TEXT_REQUIRED_VALIDATION:"Vyžaduje sa text správy",
    NEWS_TITLE_REQUIRED_VALIDATION:"Vyžaduje sa názov správy",
    DEACTIVATE:"Deaktivácia",
    ASIDE_MENU_LOCAL_TOKENS:"Miestne žetóny",
    CREATE_NEW_LOCAL_TOKENS:"Vydanie nových miestnych žetónov",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Zadajte e-mailovú adresu zákazníka a množstvo miestnych žetónov, ktoré chcete zákazníkovi vydať.",
    CREATE_TOKENS:"Vydávanie žetónov",
    MINIMUM_ONE_TOKEN:"Hodnota musí byť číslo väčšie ako 0",
    CUSTOMER_EMAIL:"E-mail zákazníka",
    AMOUNT_OF_TOKENS:"Množstvo žetónov",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Úspech pri vydávaní miestnych žetónov",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Pri vydávaní miestnych žetónov došlo k chybe. Skontrolujte prosím e-mailovú adresu zákazníka a skúste to znova.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Prehľad vydaných miestnych žetónov",
    ISSUED_AT:"Vydané v",
    ISSUED_BY:"Vydal",
    CODE:"Uplatniť kód",
    REDEEMED_BY:"Uplatnil(a)",
    REDEEMED_AT:"Uplatnené v",
    ASIDE_MENU_VOUCHERS:"Poukazy",
    PRINT:"Tlač",
    VOUCHERS_OVERVIEW:"Prehľad poukazov",
    CREATE_NEW_VOUCHERS:"Vytvorenie nových poukazov",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Vytvorte novú sériu poukazov na uplatnenie zadaním počtu žetónov na jeden poukaz.",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Množstvo žetónov na jeden poukaz",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Na jeden poukaz môžete priradiť 1 až 100 žetónov.",
    NUMBER_OF_NEW_VOUCHERS:"Počet poukazov, ktoré sa majú vytvoriť",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"V jednej sérii môžete vytvoriť 1 až {{size}} poukazov",
    NEW_VOUCHERS_PREFIX:"Predpona kódu novej série poukazov",
    VALIDATION_VOUCHER_PREFIX:"Predpona kódu musí mať presne 4 znaky (veľké písmená a/alebo číslice)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Vyskytol sa problém s vytváraním nových poukazov. Skúste to prosím znova alebo kontaktujte našu podporu.",
    CREATE_VOUCHERS:"Vytvorenie poukazov",
    CREATING_VOUCHERS_SUCCESS:"Úspešne vytvorené nové poukazy",
    PRINT_NEW_VOUCHERS:"Tlač poukazov",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Zadajte prefix kódu série poukazov, aby ste mohli vytlačiť celú sériu poukazov. Prípadne",
    PRINT_VOUCHERS_PREFIX:"Predpona kódu poukazu (série)",
    NO_VOUCHERS_FOR_PRINT:"Neboli nájdené žiadne poukazy zodpovedajúce zadanému kódu pre tlač",
    PRINT_VOUCHERS:"Vytlačiť poukaz(y)",
    VALIDATION_VOUCHER_CODE_FILTER:"Vyhľadávaný výraz poukazu musí pozostávať z veľkých písmen a číslic",
    FILTER_VOUCHERS_BY_CODE:"Vyhľadávanie poukazov podľa kódu uplatnenia",
    FILTER_VOUCHERS:"Vyhľadávanie poukazov",
    WASH_BOX:"Umývací box",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Celkovo použitých digitálnych tokenov",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Celkový počet predaných miestnych žetónov podľa dátumu",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Celkový počet použitých miestnych žetónov podľa dátumu",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Celkový počet daných miestnych žetónov podľa dátumu",
    LOCAL_TOKEN:"Miestny žetón",
    GIVEN_TOKEN:"Dané lokálne žetóny",
    SOLD_TOKEN:"Predané miestne žetóny",
    SMALL_MACHINES:"Malé stroje",
    R2W_Listener:"Poslucháč",
    HHANLE_DEVICE:"Umývací box HHanle",
    CODE_PREFIX_EXIST:"Predpona kódu už existuje",
    CODE_PREFIX_EXIST_TEXT:"Nemôžete vytvoriť nový poukaz s touto predvoľbou kódu. Prosím, nastavte iný.",
    MIN_FOUR_VALIDATION:"Presne 4 znaky",
    ALL_INFORMATION_1:"Všetky informácie o",
    ALL_INFORMATION_2:"sa stratia",
    ASIDE_MENU_TRANSACTIONS:"Transakcie",
    EXPENSES:"Výdavky",
    TOPUPS:"Doplnenia",
    EXPENSES_LIST:"Zoznam výdavkov",
    USER_EMAIL:"E-mail používateľa",
    COMPANY_NAME:"Názov spoločnosti",
    TOPUPS_LIST:"Zoznam doplnených položiek",
    CONSUMER:"Spotrebiteľ",
    SYSTEM_ADMIN:"Správca systému",
    MERCHANT_ADMIN:"Správca obchodníka",
    COMPANY_ADMIN:"Správca spoločnosti",
    FACILITY_ADMIN:"Správca zariadenia",
    SUBSCRIBER:"Predplatiteľ",
    CONFIGURATOR:"Konfigurátor",
    SETUP_UNIT_SERIAL_NO:"Sériové číslo",
    SETUP_UNIT_MATERIAL_NO:"Číslo materiálu",
    SETUP_UNIT_WEBAPI_VERSION:"Verzia WebApi",
    TOTAL_TURNOVER:"Obrat umývacieho zariadenia",
    AVAILABILITY_ALL:"Dostupnosť",
    AVAILIBILITY:"Dostupnosť umývacích boxov:",
    AVAILABILITY_VACUUMS:"Dostupnosť vysávačov:",
    WASH_BOX_INFO:"Informácie o umývacích boxoch",
    VACUUM_CLEANER_INFO:"Informácie o vysávačoch",
    BREAD_CRUMBS_SERVICE:"Služba",
    HOLIDAYS:"Dovolenky",
    HOLIDAY:"Dovolenka",
    LIGHTS_ON:"Zapnuté svetlá",
    LIGHTS_OFF:"Vypnuté svetlá",
    WASH_BOXES_ON:"Umývací box zapnutý",
    WASH_BOXES_OFF:"Umývací box vypnutý",
    VACUUMS_ON:"Vysávače zapnuté",
    VACUUMS_OFF:"Vysávače vypnuté",
    TURNOVER:"Obrat",
    TURNOVER_MANUAL_WASH_UNIT:"Manuál obratu",
    STATUS_BAY_RUN_TIME:"Celkový pracovný čas umývacieho boxu",
    STATUS_BAY_PROGRAM_NAME:"Názov programu",
    STATUS_BAY_CREDIT:"Kredit na umývací box",
    CLOUD_KREDIT:"Kredit na cloude",
    STATUS_VACUUM_RUN_TIME:"Celkový pracovný čas vysávača",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Informácie o službách zariadenia, programe umývacieho boxu a aktuálnych údajoch o poruchách",
    UNAVAILABLE:"Jednotka nie je k dispozícii",
    SHOW_HIDE_TABLE:"Zobraziť/skryť tabuľku pracovného času",
    PROGRAM_NAME:"Názov programu",
    PROGRAM_OPTION:"Možnosť programu",
    DEVICE:"Zariadenie",
    QUANTITY:"Množstvo",
    PROGRAM_COUNTER:"Počítadlo programov",
    NO_NAME:"Odkaz nemá meno",
    COUNTER_SERVICE_DATA:"Údaje o službách",
    NEED_SERVICE:"Potrebná služba",
    PROGRAM_DATA:"Údaje o programe umývacieho boxu",
    CURRENT_FAULT_DATA:"Aktuálne údaje o poruche",
    REFERENCE_DUE:"Splatné",
    REFERENCE_SECONDS:"Sekundy",
    REFERENCE_NAME:"Názov časti",
    WASHBOX_NAME:"Názov umývacieho boxu",
    FAULT_NAME:"Názov poruchy",
    FAULT_NUMBER:"Číslo poruchy",
    CURRENT_FAULT_COUNT:"Aktívne poruchy",
    DEVICE_NOT_INSTALLED:"Zariadenie nie je nainštalované",
    STATUS_READY:"Stav pripravenosti",
    STATUS_ERROR:"Stav chyby",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Chyba softvéru",
    SOFTWARE_RESET:"Chyba softvéru",
    EXTERNAL_PIN_RESET:"Chyba softvéru",
    RESTART_OR_BROWNOUT_OCCURRED:"Chyba softvéru",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Chyba hardvéru",
    COULD_NOT_SIMULATE_COIN:"Chyba hardvéru",
    ERROR_SETTING_INHIBIT_MODE:"Chyba hardvéru",
    OFFLINE_DEVICE:"Umývačka áut vypnutá",
    TARIFFS:"Tarify",
    DAY:"Deň",
    NIGHT:"Noc",
    VOUCHER_CODE:"Kód kupónu",
    DISMISS_ALARM:"Resetovať alarm?",
    ALARM_ACTIVE:"Aktívne alarmy",
    NO_ALARM_ACTIVE:"Neexistujú žiadne aktívne alarmy",
    ALARM_HISTORY:"História alarmov",
    MANAGING_TOKENS:"Správa žetónov",
    EXPIRATION_DATE:"Dátum skončenia platnosti",
    EXTEND_TOKEN_DATE:"Predĺžiť platnosť žetónov pre",
    DELETE_TOKENS_FOR:"Odstránenie žetónov pre",
    PUMP_TYPE:"Typ čerpadla",
    TURN_OFF_DEVICE:"Stav zariadenia",
    OPERATION_DATA:"Prevádzkové údaje",
    PUMP_DATA:"Údaje o čerpadle",
    PUMP_NAME:"Názov čerpadla",
    POINT_NAME:"Názov bodu",
    CHANGER_INCOME:"Celkové príjmy z meničky podľa dátumu",
    SELECTED_OPEN:"Otvorené vo vybraných pracovných hodinách",
    ALWAYS_OPEN:"Vždy otvorené (24/7)",
    CLOSED:"Zatvorené",
    CLOSED_24:"Zatvorené 24 hodín denne",
    OPENED_24:"Otvorené 24 hodín denne",
    MON:"Pondelok",
    TUE:"Utorok",
    WED:"Streda",
    THU:"Štvrtok",
    FRI:"Piatok",
    SAT:"Sobota",
    SUN:"Nedeľa",
    PRICING:"Cenová ponuka",
    PRICE:"Cena",
    VALIDITY:"Platnosť",
    TOKEN_PACKAGES:"Balíky žetónov",
    SINGLE_WASH:"Jednorazové umývanie",
    FACILITY_WORKING_HOURS:"Nastavenie pracovného času pre vybrané zariadenie",
    WORKING_HOURS_ALWAYS_OPEN:"Vždy otvorené",
    WORKING_HOURS_ALWAYS_CLOSE:"Uzavreté operátorom",
    WORKING_HOURS_CUSTOM:"Nastavenie pracovného času",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizácia",
    CREATE_ORGANIZATION:"Vytvoriť organizáciu",
    CREATE_ORGANIZATION_AS:"Vytvoriť organizáciu ako podradenú",
    DELETE_ORGANIZATION:"Odstrániť organizáciu",
    EDIT_ORGANIZATION:"Upraviť organizáciu",
    SUPPORTED_ORG_NAME:"Podporovaná organizácia",
    SUPPORTED_ORG_TYPE:"Podporovaný typ",
    ORG_NAME:"Názov",
    ORG_TYPE:"Typ",
    SET_ORG_TITLE:"Nastavenie organizácie detí",
    SET_SUPPORTED_ORG_TITLE:"Nastavenie podporovanej detskej organizácie",
    SAVE_ORGANIZATION:"Uložiť organizáciu",
    SELECT_ORGANIZATION_TYPE:"Vyberte typ organizácie",
    SELECT_ORGANIZATION_SELECTOR:"Vyberte",
    SELECT_SUPPORTED_ORGANIZATION:"Podporované",
    ORGANIZATION_DELETED:"Organizácia úspešne vymazaná",
    ORGANIZATION_SAVED:"Organizácia úspešne uložená",
    ORGANIZATION_UPDATED:"Organizácia úspešne aktualizovaná",
    ALERTS:"Upozornenia",
    DEVICE_STATUS:"Stav zariadenia",
    SITE_DETAILS:"Podrobnosti o lokalite",
    ALARM_STATUS:"Stav upozornenia",
    FILTER:"Filtrovanie podľa ...",
    FILTER_BY_ALERT_CENTER:"Filtrovanie podľa kódu, názvu alebo opisu",
    TOTAL_ALARM:"Celkom",
    LOW_ALARM:"Udalosť",
    MEDIUM_ALARM:"Porucha",
    HIGH_ALARM:"Kritická porucha",
    NO_FACILITIES_NEARBY:"V blízkosti sa nenachádzajú žiadne zariadenia",
    GRAY_MAP:"Mapa v sivom štýle",
    READY:"Pripravené",
    WARNING:"Porucha",
    ERROR:"Chyba",
    SITE_NAME:"Názov lokality",
    ACCOUNTS_INFO:"Informácie o účte",
    USER_ORGANIZATION:"Organizácia používateľov",
    ADD_USER_ORGANIZATION:"Pridanie nového používateľa organizácie",
    EDIT_USER_ORGANIZATION:"Úprava používateľov organizácie",
    SELECT_ROLE:"Vyberte rolu",
    SELECT_ORGANIZATION:"Vybrať organizáciu",
    SELECT_USER:"Vyberte používateľa",
    USER_FOR_ORGANIZATION_CREATED:"Úspešne vytvorený nový používateľ",
    SELECT_REGION:"Výber regiónu",
    SELECT_LANGUAGE:"Výber jazyka",
    LOADING_DATA:"Načítavanie údajov, počkajte, prosím...",
    ADMINISTRATOR:"Správca",
    TECHNICAL_SUPPORT:"Technická podpora",
    CONTROLLER:"Ovládač",
    EDIT_ORGANIZATION_USER:"Úprava používateľov organizácie",
    DELETE_ORGANIZATION_USER:"Odstránenie používateľov organizácie",
    USER_UPDATED:"Používateľ úspešne aktualizovaný",
    USER_CREATED:"Používateľ bol úspešne vytvorený",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Predplatné",
    RESOLVED_STATUS:"Vyriešené",
    NOT_RESOLVED_STATUS:"Nie je vyriešené",
    ALERT_NAME:"Názov upozornenia",
    ALERT_DESCRIPTION:"Popis upozornenia",
    ALERT_CODE:"Kód upozornenia",
    ALERT_TYPE:"Typ upozornenia",
    UNSUBSCRIBE:"Upozornenie na zrušenie odberu",
    SUBSCRIBE:"Upozornenie na odber",
    ALARM_SUBSCRIBED:"Úspešne prihlásený k odberu",
    UNSUBSCRIBED_CONFIRM:"Odhlásiť sa z odberu?",
    ALARM_UNSUBSCRIBED:"Úspešne odhlásený z odberu",
    ASIDE_MENU_CASHLESS_SALES:"Bezhotovostný predaj",
    FILTERED_CASHLESS_PAYMENTS:"Filtrované bezhotovostné platby",
    REFUND_DIALOG_TITLE:"Transakcia vrátenia peňazí?",
    REFUND_DIALOG_SUBTITLE:"Suma môže byť nižšia alebo rovná sume transakcie",
    REFUND:"Vrátenie peňazí",
    INPUT_NOT_VALID:"Vstup nie je platný",
    REFUND_SUCCESSFULLY:"Refundácia vybranej platby bola úspešne vykonaná",
    USER:"Používateľ",
    TRANSACTION_ID:"Odkaz na systém PSP",
    DEVICE_ID:"ID zariadenia",
    NET_AMOUNT:"Čistá suma",
    TRANSACTION_STATUS:"Stav transakcie",
    REPORT_NAME:"Názov správy",
    TIME_FRAME:"Časový rámec",
    SUB_POINT:"Výber vedľajšieho bodu",
    SUB_POINT_LIST_NOT_EXIST:"Zoznam podbodov neexistuje pre vybrané umývacie zariadenie",
    FACILITY_TYPE:"Typ zariadenia",
    MACHINE_NAME:"Názov stroja",
    WASH_FACILITY_DETAILS:"Podrobnosti o umývacom zariadení",
    WASH_BAY_DETAILS:"Podrobnosti o umývacom priestore",
    DEVICES_INFO:"Zoznam zariadení",
    OPERATION_TIME_INFO:"Čas prevádzky",
    OPERATION_TIME_VACUUM_INFO:"Prevádzkový čas vysávačov",
    OPERATION_TIME_ILLUMINATION_INFO:"Prevádzkový čas osvetlenia",
    AVAILABLE_TITLE:"Dostupné",
    UNAVAILABLE_TITLE:"Nedostupné",
    CURRENT_PROGRAM:"Aktuálny program",
    CREDITS:"Kredity",
    DEVICE_NAME:"Názov zariadenia",
    ACTIVE_ALARMS:"Aktívne upozornenia",
    ALL_DAY:"Celý deň",
    OPERATING_TIME_WASH_FACILITY:"Samoobslužný umývací systém",
    OPERATING_TIME_VACUUMS:"Vysávače",
    OPERATING_TIME_ILLUMINATION:"Osvetlenie",
    OPERATION_COUNTERS:"Počítadlá operácií",
    EDIT:"Upraviť",
    WASHING_PROGRAMS:"Umývacie programy",
    INFO:"Udalosť",
    STATISTIC:"Štatistika",
    ROLLOVER_DOSING:"Dávkovanie",
    ROLLOVER_SPEED:"Rýchlosti",
    ROLLOVER_RESETS:"Diaľkové resetovanie pri Rollover",
    ROLLOVER_RESETS_INFO:"Diaľkový reset musí byť v súlade s miestnymi predpismi. Dôležité: Pred resetovaním sa uistite, že je rollover prázdny.",
    RESET_ROLLOVER:"Obnovenie rollover",
    OPEN_DOOR_ROLLOVER:"Otvoriť",
    ROLLOVER_OPEN_DOOR_INFO:"Otvorte dvere umývacej haly. Buďte opatrní.",
    ROLLOVER_OPEN_DOOR:"Otvorte dvere",
    APPLY_DOSING_CHANGES:"Aplikujte zmeny dávkovania",
    APPLY_SPEED_CHANGES:"Aplikovať zmeny rýchlosti",
    ACTUATION_SUCCESS:"Odoslanie žiadosti",
    REMAINING_TIME:"Zostávajúci čas",
    OPEN_24H:"Otvoriť 24 hodín",
    CLOSE_24H:"Zavrieť 24 hodín",
    VALIDATION_OPERATION_TIME:"Formát nie je správny. Použite hh:mm",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Aktualizácia pracieho programu",
    UPDATE_ACTUATORS:"Aktualizácia aktuátorov",
    OPEN_ROLOVER_DOOR_TITLE:"Chcete otvoriť rollover dvere?",
    OPEN_ROLOVER_DOOR_CONTENT:"Určite chcete otvoriť dvere?",
    RESET_ROLOVER_TITLE:"Chcete obnoviť rollover?",
    RESET_ROLOVER_CONTENT:"Ste si istí, že chcete obnoviť rollover?",
    G0:"Stanica 1",
    G1:"Stanica 2",
    G2:"Stanica 3",
    G3:"Stanica 4",
    G4:"Stanica 5",
    G5:"Stanica 6",
    G6:"Stanica 7",
    G7:"Stanica 8",
    G8:"Stanica 9",
    G9:"Stanica 10",
    G10:"Stanica 11",
    U0:"Vysávač 1",
    U1:"Vysávač 2",
    U2:"Vysávač 3",
    U3:"Vysávač 4",
    U4:"Vysávač 5",
    U5:"Vysávač 6",
    U6:"Vysávač 7",
    U7:"Vysávač 8",
    ALERT_CENTER_TITLE_BY_SITE:"Správa centra výstrah vytvorená vybraným miestom z prístrojového panela",
    ALERT_CENTER_TITLE_BY_FACILITY:"Správa centra výstrah vytvorená vybraným zariadením z prístrojového panela",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Správa centra varovania",
    ERROR_MESSAGE_403:"Na použitie tohto volania api nemáte oprávnenie. Kód chyby: 403",
    LAST_ACTIVE_PROGRAM:"Aktívny program / Posledný aktívny program",
    PROGRAM_ID:"Číslo programu",
    PROGRAM_PRICE:"Cena programu",
    PROGRAM_DESCRIPTION:"Popis programu",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Potrebné doplnenie",
    EMPTY_CHEMICAL_LEVEL:"Prázdne",
    CHEMICAL_LEVEL:"Úroveň indikácie detergentov (%)",
    ROLLOVER_STATUS:" Rollover status",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kritická porucha",
    NO_ALARM:"Žiadna kritická porucha",
    SOFTWARE_VERSION:"Verzia softvéru",
    SOFTWARE_DATE:"Dátum softvéru",
    SITE_ADDRESS:"Adresa lokality",
    SECONDS:"Sekundy",
    SERVICE_PART_NAME:"Názov služby:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Prevádzkový a servisný pult",
    OPERATION_COUNTER:"Počítadlo operácií",
    SERVICE_COUNTER:"Servisný pult",
    FAULT_CODE:"Kód upozornenia",
    PRESSURE_TITLE:"Tlak vzduchu",
    TIME_TITLE:"Aktuálny čas",
    COUNTRY_TITLE:"Krajina",
    CITY_TITLE:"Mesto",
    REGION_TITLE:"Región",
    SELECT_POINTS_TO_SEARCH:"Vyberte body...",
    LOGS_HISTORY:"História zmien parametrov",
    ACTUATOR_REFERENCE:"Referencia na aktuátor",
    ACTUATOR_VALUE:"Hodnota aktuátora",
    POINT_ID:"Identifikátor bodu",
    VALIDATION_NOT_VALID_RANGE:"Nesprávny rozsah",
    ENABLE_ROLLOVER_RESET:"Zaškrtnutím tohto políčka potvrdzujete, že ste si prečítali bezpečnostné pokyny a súhlasíte s nimi.",
    CHANGE_OF_PARAMETERS:"Zmena parametrov",
    SELECT_OPTIONS:"Vyberte možnosti",
    AUTOMATIC:"Automatické",
    DESALTING:"Funkcia odsoľovania",
    SEASON_WASH:"Sezónne umývacie programy",
    SPRING_PROGRAM:"Jarné umývacie programy",
    SUMMER_PROGRAM:"Letné umývacie programy",
    AUTUMN_PROGRAM:"Jesenné umývacie programy",
    WINTER_PROGRAM:"Zimné umývacie programy",
    DOOR_CONTROL:"Ovládanie dverí",
    SUMMER_DOOR_CONTROL:"Letný režim, ovládané s riadením brány v letnom režime",
    WINTER_DOOR_CONTROL:"Zimný režim, ovládané s riadením brány v zimnom režime",
    APPLY_PARAMETERS_CHANGES:"Aplikovať zmeny parametrov",
    WORKING_SCHEDULES:"Pracovné harmonogramy",
    HOLIDAY_SCHEDULES:"Dovolenkové rozvrhy",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Dovolenka na mieste úspešne vytvorená",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Dovolenka na mieste úspešne aktualizovaná",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Dovolenka na stránke úspešne odstránená",
    WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Pracovné plány na mieste úspešne aktualizované",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Pracovné plány boli úspešne aplikované.",
    HOLIDAY_SUCCESSFULLY_DELETED:"Dovolenka úspešne odstránená",
    SB_MU_MB_2_2_0:" SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:" SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:" SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:" SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:" SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:" SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:" SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:" SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:" SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:" CB3_1_0_0_Trans",
    CW35_3_0_0:" CW35_3_0_0_Trans",
    CW35_3_1_0:" CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:" CWB3_3_1_0_Trans",
    CW1_3_0_0:" CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sušiaci prostriedok s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampón s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_FOAM:"Pena s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_WAX_1:"Vosk s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_POLISH_1:"Leštenka s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistič diskov s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_WAX_2:"Vosk s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Lesk na pneumatiky s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Odstraňovač hmyzu s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_POLISH_2:"Leštenka s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzívny prostriedok s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pena „dážď“ s nízkou hladinou náplne",
    CHEM_LEVEL_DRYING_AGENT:"Hladina náplne – sušiaci prostriedok",
    CHEM_LEVEL_SHAMPOO:"Hladina náplne – šampón",
    CHEM_LEVEL_FOAM:"Hladina náplne – pena",
    CHEM_LEVEL_WAX_1:"Hladina náplne – vosk",
    CHEM_LEVEL_POLISH_1:"Hladina náplne – leštenka",
    CHEM_LEVEL_RIM_CLEANER:"Hladina náplne – čistič diskov",
    CHEM_LEVEL_WAX_2:"Hladina náplne – vosk",
    CHEM_LEVEL_TYRE_SHINE:"Hladina náplne – lesk na pneumatiky",
    CHEM_LEVEL_INSECT_REMOVER:"Hladina náplne – odstraňovač hmyzu",
    CHEM_LEVEL_POLISH_2:"Hladina náplne – leštenka",
    CHEM_LEVEL_INTENSIVE:"Hladina náplne – intenzívny prostriedok",
    CHEM_LEVEL_FOAM_RAIN:"Hladina náplne – pena „dážď“",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servisný pult – zdvíhací pás strešnej kefy",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servisný pult – zdvíhací pás sušiča",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servisný pult – kábel motora strešnej kefy",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servisný pult – servis čerpadla čerstvej vody",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servisný pult – servis čerpadla použitej vody",
    DRYING_AGENT:"Sušiaci prostriedok",
    FOAM_DRYING_AGENT:"Pena na sušenie",
    SHAMPOO:"Šampón",
    FOAM:"Pena",
    BRUSH_FOAM:"Pena na kefy",
    WAX_1:"Vosk",
    FOAM_WAX_1:"Penový vosk",
    POLISH_1:"Lak",
    RIM_CLEANING:"Čistič ráfikov",
    WAX_2:"Vosk",
    FOAM_WAX_2:"Penový vosk",
    TYRE_SHINE:"Lesk pneumatík",
    INSECT_REMOVER:"Odstraňovač hmyzu",
    POLISH_2:"Lak",
    INTENSIVE_BASIC:"Intenzívne základné",
    INTENSIVE_SIDE:"Intenzívna strana",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzívny strešný postrekovač",
    TAR_REMOVER:"Odstraňovač dechtu",
    UNDER_CHASSIS_CONVERSATION:"Úprava podvozku",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionárny oblúk na predstriekanie",
    FOAM_RAIN:"Penový dážď",
    PRE_CLEANING:"Predbežné čistenie",
    BRUSH:"Kefa",
    CARE:"Starostlivosť",
    DRYING:"Sušenie",
    DRYING_LOW_NOISE:"Sušenie so zníženou hlučnosťou",
    INTENSIVE_CLEANING:"Intenzívne čistenie",
    BRUSH_CLEANING:"Čistenie kefou",
    EMPTY_RUN:"Beh na prázdno",
    DRYING_AID:"Prostriedok na sušenie",
    WAX:"Vosk",
    FOAM_WASH:"Umývacia pena",
    POLISH:"Lak",
    FOAM_POLISH:"Penový lak",
    WHEEL_CLEANING:"Čistenie kolies",
    HIGH_PRESSURE_ROOF:"Vysokotlakové čistenie strechy",
    HIGH_PRESSURE_SIDE:"Bočné vysokotlakové čistenie",
    DRYER_FORWARD:"Sušička dopredu",
    DRYER_BACKWARD:"Sušička dozadu",
    DELETE_ALL_HOLIDAYS:"Odstránenie všetkých sviatkov pre vybranú lokalitu",
    CREATE_NEW_HOLIDAY:"Vytvorenie nového",
    RESET_INPUTS:"Obnovenie všetkých nastavení dovolenky",
    TWENTY_FOUR_HOURS_OPEN:"Otvorené 24 hodín",
    EVERY_YEAR:"Ročný",
    DELETE_HOLIDAY:"Vymazať dovolenku",
    ADD_NEW_HOLIDAY:"Pridať novú dovolenku",
    HOLIDAYS_LIST:"Zoznam existujúcich sviatkov",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Odstrániť všetky sviatky pre vybranú lokalitu?",
    VALIDATION_HOLIDAY_DATE:"Formát nie je správny. Použite mm-dd",
    FOR_DATE:"Na dátum",
    WITH_ID:"S preukazom totožnosti",
    FROM_HOURS:"Od h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (min)",
    NOT_MATCH:"Nezodpovedá",
    START:"Štart",
    STOP:"Stop",
    DAILY_TIME:"Zoznam 24 hodín",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuálne nastavenie času",
    PROGRAM_NOT_STARTED:"Program sa ešte nezačal",
    JETWASH:"Samoobslužný umývací systém",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Čerpadlo na čerstvú vodu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Čerpadlo na procesnú vodu",
    OPERATION_COUNTER_HP_PUMP_1:"Vysokotlakové čerpadlo 1",
    OPERATION_COUNTER_HP_PUMP_2:"Vysokotlakové čerpadlo 2",
    RELEASE_NOTES:"Verzie aplikácií a poznámky k vydaniu",
    BACKEND_RELEASE_NOTES:"Poznámky k vydaniu platformy:",
    FRONTEND_RELEASE_NOTES:"Poznámky k vydaniu webovej aplikácie:",
    SELECTED_FACILITY_TIMEZONE:"Časové pásmo pre vybrané zariadenie:",
    REFRESH_PAGE:"Obnoviť stránku",
    REFRESH_MAPS:"Obnovenie máp",
    PUMPS:"Čerpadlá",
    RUN_TIME:"Čas prevádzky",
    RUN_TIME1:"Čas prevádzky 1 ",
    RUN_TIME2:"Čas prevádzky 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuátor pre čas chodu",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuátor pre čas chodu 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuátor pre čas chodu 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimálna hodnota je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maximálna hodnota je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Použite formát ceny x.xx",
    ACTUATION_NOT_ALLOWED:"Aktivácia nie je povolená pre aktuálnu rolu používateľa",
    MAINTENANCE_DAYS:"Dni údržby",
    MAINTENANCE_WASHES:"Umývanie na údržbu",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Celkový príjem POS",
    PROPAGATE:"Propagovať",
    ALL_DAY_HOURS_SELECTOR:"Výber typu 24 hodín",
    GET_OPERATING_TIME_FROM_SITE:"Získanie prevádzkového času pre aktuálne zariadenie z pracovných plánov pracoviska",
    USER_NOT_VALID:"Používateľ nie je platný. Skúste použiť iné prihlasovacie údaje k účtu.",
    VERIFIED:"Overené",
    RESEND_VERIFICATION_MAIL:"Opätovné odoslanie overovacieho e-mailu",
    RETURN_TO_DASHBOARD:"Návrat na prístrojovú dosku",
    ERROR_PAGE_BAD_REQUEST:"400 Zlá požiadavka.",
    WASHES:"Počet umyvaní",
    TIME_TO_SERVICE:"Čas do služby",
    ACCOUNT_ALREADY_ACTIVATED:"Účet je už aktivovaný",
    DEVICE_EVENTS:"Udalosti zariadenia",
    DEVICE_EVENTS_LOG_PULLED:"Vytiahnutý protokol udalostí pre zariadenie",
    EVENTS_PULL_DATE:"Čas vytiahnutých udalostí:",
    DEVICE_EVENTS_REFRESH:"Vytiahnutie nových údajov o udalostiach",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problém s pripojením k webovým soketom. Skúste obnoviť stránku.",
    INSTALLATION_DATE:"Dátum inštalácie stroja",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Hot wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"High pressure washing",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim foam",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Power foam",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Foam wash HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Wash",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Top care",
    INFO_TITLE:"Informácie",
    FOAM_WAX1:"Penový vosk",
    POLISH1:"Lak",
    WAX1:"Vosk",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podrobnosti o lokalite boli úspešne aktualizované",
    COMPANY:"Spoločnosť",
    FACILITY_HAS_CHANGER:"Máte meničku?",
    DISABLE_OFFLINE_ALARM:"Zakázanie alarmov R2W",
    ASIDE_WORKING_SCHEDULES:"Podrobnosti o aplikácii",
    TERMS_OF_SERVICE_R2W_TITLE:"Podmienky služby Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Podmienky služby Ready2Wash",
    DATA_PROCESSING_TITLE:"Spracované údaje",
    PRIVACY_POLICY_TITLE:"Zásady ochrany osobných údajov",
    READY_TO_PAY_TERMS_OF_SERVICE:"Podmienky služby Ready2Pay",
    TERMS_AND_SERVICES:"Podmienky a služby",
    HOURLY:"Hodinovo",
    DAILY:"Denne",
    WEEKLY:"Týždenne",
    MONTHLY:"Mesačne",
    YEARLY:"Ročne",
    DELETE_ITEM_SUCCESS:"Položka bola úspešne odstránená",
    STATE:"Stav",
    AVAILABILITY_STATUS_1:"Jednotka otvorená",
    AVAILABILITY_STATUS_2:"Jednotka zatvorená (sviatok)",
    AVAILABILITY_STATUS_3:"Jednotka zatvorená (prevádzkový čas)",
    AVAILABILITY_STATUS_4:"Jednotka zatvorená (porucha)",
    AVAILABILITY_STATUS_5:"Jednotka zatvorená (iné)",
    AVAILABILITY_VACUUMS_STATUS_1:"Vysávače nie sú nainštalované",
    AVAILABILITY_VACUUMS_STATUS_2:"Vysávače otvorené",
    AVAILABILITY_VACUUMS_STATUS_3:"Vysávače zatvorené (sviatok)",
    AVAILABILITY_VACUUMS_STATUS_4:"Vysávače zatvorené (prevádzkový čas)",
    AVAILABILITY_VACUUMS_STATUS_5:"Vysávače zatvorené (porucha)",
    AVAILABILITY_VACUUMS_STATUS_6:"Vysávače zatvorené (iné)",
    ECOM_AMOUNT:"Celkové Ecom pre všetky lokality",
    CAPTURED:"Zachytené",
    VALUE_DATE:"Dátum zaúčtovania",
    VALIDATION_HOLIDAY_YEAR:"Formát nie je správny. Použite yyyy",
    KARCHER_EVENT_NAME_1:"Base exchanger regenerated",
    KARCHER_EVENT_NAME_2:"Base exchanger regeneration ended",
    KARCHER_EVENT_NAME_3:"Material / serial number",
    KARCHER_EVENT_NAME_4:"The system has been disinfected",
    KARCHER_EVENT_NAME_5:"HP pump 1 has been disinfected",
    KARCHER_EVENT_NAME_6:"HP pump 2 has been disinfected",
    KARCHER_EVENT_NAME_7:"HP pump 3 has been disinfected",
    KARCHER_EVENT_NAME_8:"HP pump 4 has been disinfected",
    KARCHER_EVENT_NAME_9:"HP pump 5 has been disinfected",
    KARCHER_EVENT_NAME_10:"Washing station 1 locked",
    KARCHER_EVENT_NAME_11:"Washing station 2 locked",
    KARCHER_EVENT_NAME_12:"Washing station 3 locked",
    KARCHER_EVENT_NAME_13:"Washing station 4 locked",
    KARCHER_EVENT_NAME_14:"Washing station 5 locked",
    KARCHER_EVENT_NAME_15:"Washing station 6 locked",
    KARCHER_EVENT_NAME_16:"Washing station 7 locked",
    KARCHER_EVENT_NAME_17:"Washing station 8 locked",
    KARCHER_EVENT_NAME_18:"Update started",
    KARCHER_EVENT_NAME_19:"Update finished",
    KARCHER_EVENT_NAME_20:"Start WS Reg",
    KARCHER_EVENT_NAME_21:"End WS Reg",
    KARCHER_EVENT_NAME_22:"WS 75% sensor",
    KARCHER_EVENT_NAME_23:"Tech. defect",
    KARCHER_EVENT_NAME_24:"Oper. defect",
    KARCHER_EVENT_NAME_25:"Unit on",
    KARCHER_EVENT_NAME_26:"Unit closed",
    KARCHER_EVENT_NAME_27:"Box 1 closed",
    KARCHER_EVENT_NAME_28:"Box 2 closed",
    KARCHER_EVENT_NAME_29:"Box 3 closed",
    KARCHER_EVENT_NAME_30:"Box 4 closed",
    KARCHER_EVENT_NAME_31:"Box 5 closed",
    KARCHER_EVENT_NAME_32:"Box 6 closed",
    KARCHER_EVENT_NAME_33:"Box 7 closed",
    KARCHER_EVENT_NAME_34:"Box 8 closed",
    KARCHER_EVENT_NAME_35:"HP pump bay 1",
    KARCHER_EVENT_NAME_36:"HP pump bay 2",
    KARCHER_EVENT_NAME_37:"HP pump bay 3",
    KARCHER_EVENT_NAME_38:"HP pump bay 4",
    KARCHER_EVENT_NAME_39:"HP pump bay 5",
    KARCHER_EVENT_NAME_40:"HP pump bay 6",
    KARCHER_EVENT_NAME_41:"HP pump bay 7",
    KARCHER_EVENT_NAME_42:"HP pump bay 8",
    KARCHER_EVENT_NAME_43:"Burner",
    KARCHER_EVENT_NAME_44:"Burner fan",
    KARCHER_EVENT_NAME_45:"Warm water pump",
    KARCHER_EVENT_NAME_46:"Freeze prot.pump",
    KARCHER_EVENT_NAME_47:"Osmosis pump",
    KARCHER_EVENT_NAME_48:"Floor heating",
    KARCHER_EVENT_NAME_49:"Hose heating",
    KARCHER_EVENT_NAME_50:"Microe/rim clean",
    KARCHER_EVENT_NAME_51:"Underc. pump",
    KARCHER_EVENT_NAME_52:"Booster pumpFoam",
    KARCHER_EVENT_NAME_53:"Vacuum clean. 1",
    KARCHER_EVENT_NAME_54:"Vacuum clean. 2",
    KARCHER_EVENT_NAME_55:"Vacuum clean. 3",
    KARCHER_EVENT_NAME_56:"Vacuum clean. 4",
    KARCHER_EVENT_NAME_57:"Vacuum clean. 5",
    KARCHER_EVENT_NAME_58:"Vacuum clean. 6",
    KARCHER_EVENT_NAME_59:"Vacuum clean. 7",
    KARCHER_EVENT_NAME_60:"Vacuum clean. 8",
    KARCHER_EVENT_NAME_61:"Vacuum clean. 9",
    KARCHER_EVENT_NAME_62:"Vacuum clean. 10",
    KARCHER_EVENT_NAME_63:"Vacuum clean. 11",
    KARCHER_EVENT_NAME_64:"Vacuum clean. 12",
    KARCHER_EVENT_NAME_65:"Pump rim clean",
    KARCHER_EVENT_NAME_66:"Pump Microe.",
    KARCHER_EVENT_NAME_67:"Pump Intensive",
    KARCHER_EVENT_NAME_68:"Vacuum1 turbine",
    KARCHER_EVENT_NAME_69:"Vacuum1 filter",
    KARCHER_EVENT_NAME_70:"Vacuum2 turbine",
    KARCHER_EVENT_NAME_71:"Vacuum2 filter",
    KARCHER_EVENT_NAME_72:"Vacuum3 turbine",
    KARCHER_EVENT_NAME_73:"Vacuum3 filter",
    KARCHER_EVENT_NAME_74:"Vacuum4 turbine",
    KARCHER_EVENT_NAME_75:"Vacuum4 filter",
    KARCHER_EVENT_NAME_76:"Vacuum5 turbine",
    KARCHER_EVENT_NAME_77:"Vacuum5 filter",
    KARCHER_EVENT_NAME_78:"Vacuum6 turbine",
    KARCHER_EVENT_NAME_79:"Vacuum6 filter",
    KARCHER_EVENT_NAME_80:"Vacuum7 turbine",
    KARCHER_EVENT_NAME_81:"Vacuum7 filter",
    KARCHER_EVENT_NAME_82:"Vacuum8 turbine",
    KARCHER_EVENT_NAME_83:"Vacuum8 filter",
    KARCHER_EVENT_NAME_84:"Vacuum9 turbine",
    KARCHER_EVENT_NAME_85:"Vacuum9 filter",
    KARCHER_EVENT_NAME_86:"Vacuum10 turbine",
    KARCHER_EVENT_NAME_87:"Vacuum10 filter",
    KARCHER_EVENT_NAME_88:"Vacuum11 turbine",
    KARCHER_EVENT_NAME_89:"Vacuum11 filter",
    KARCHER_EVENT_NAME_90:"Vacuum12 turbine",
    KARCHER_EVENT_NAME_91:"Vacuum12 filter",
    INSERT_TOKEN:"Vložte žetóny a spustite službu",
    OPEN_SESSION:"Relácia bola úspešne spustená",
    IN_PROGRESS:"Prebieha ...",
    TOKEN_INSERTED:"Žetóny boli úspešne vložené",
    EXPIRED_SESSION:"Relácia vypršala",
    TWO_DIGIT_INTEGER_VALIDATION:"Použite maximálne dvojciferné celé číslo",
    KARCHER_OPERATION_COUNTER_1:"Washing station 1 HP pump",
    KARCHER_OPERATION_COUNTER_2:"Washing station 1 chemical pump 1",
    KARCHER_OPERATION_COUNTER_3:"Washing station 1 chemical pump 2",
    KARCHER_OPERATION_COUNTER_4:"Washing station 1 chemical pump 3",
    KARCHER_OPERATION_COUNTER_5:"Washing station 1 chemical pump 4",
    KARCHER_OPERATION_COUNTER_6:"Washing station 2 HP pump",
    KARCHER_OPERATION_COUNTER_7:"Washing station 2 chemical pump 1",
    KARCHER_OPERATION_COUNTER_8:"Washing station 2 chemical pump 2",
    KARCHER_OPERATION_COUNTER_9:"Washing station 2 chemical pump 3",
    KARCHER_OPERATION_COUNTER_10:"Washing station 2 chemical pump 4",
    KARCHER_OPERATION_COUNTER_11:"Washing station 3 HP pump",
    KARCHER_OPERATION_COUNTER_12:"Washing station 3 chemical pump 1",
    KARCHER_OPERATION_COUNTER_13:"Washing station 3 chemical pump 2",
    KARCHER_OPERATION_COUNTER_14:"Washing station 3 chemical pump 3",
    KARCHER_OPERATION_COUNTER_15:"Washing station 3 chemical pump 4",
    KARCHER_OPERATION_COUNTER_16:"Washing station 4 HP pump",
    KARCHER_OPERATION_COUNTER_17:"Washing station 4 chemical pump 1",
    KARCHER_OPERATION_COUNTER_18:"Washing station 4 chemical pump 2",
    KARCHER_OPERATION_COUNTER_19:"Washing station 4 chemical pump 3",
    KARCHER_OPERATION_COUNTER_20:"Washing station 4 chemical pump 4",
    KARCHER_OPERATION_COUNTER_21:"Washing station 5 HP pump",
    KARCHER_OPERATION_COUNTER_22:"Washing station 5 chemical pump 1",
    KARCHER_OPERATION_COUNTER_23:"Washing station 5 chemical pump 2",
    KARCHER_OPERATION_COUNTER_24:"Washing station 5 chemical pump 3",
    KARCHER_OPERATION_COUNTER_25:"Washing station 5 chemical pump 4",
    KARCHER_OPERATION_COUNTER_26:"Washing station 6 HP pump",
    KARCHER_OPERATION_COUNTER_27:"Washing station 6 chemical pump 1",
    KARCHER_OPERATION_COUNTER_28:"Washing station 6 chemical pump 2",
    KARCHER_OPERATION_COUNTER_29:"Washing station 6 chemical pump 3",
    KARCHER_OPERATION_COUNTER_30:"Washing station 6 chemical pump 4",
    KARCHER_OPERATION_COUNTER_31:"Washing station 7 HP pump",
    KARCHER_OPERATION_COUNTER_32:"Washing station 7 chemical pump 1",
    KARCHER_OPERATION_COUNTER_33:"Washing station 7 chemical pump 2",
    KARCHER_OPERATION_COUNTER_34:"Washing station 7 chemical pump 3",
    KARCHER_OPERATION_COUNTER_35:"Washing station 7 chemical pump 4",
    KARCHER_OPERATION_COUNTER_36:"Washing station 8 HP pump",
    KARCHER_OPERATION_COUNTER_37:"Washing station 8 chemical pump 1",
    KARCHER_OPERATION_COUNTER_38:"Washing station 8 chemical pump 2",
    KARCHER_OPERATION_COUNTER_39:"Washing station 8 chemical pump 3",
    KARCHER_OPERATION_COUNTER_40:"Washing station 8 chemical pump 4",
    KARCHER_OPERATION_COUNTER_41:"Osmosis pump",
    KARCHER_OPERATION_COUNTER_42:"Hot water generator",
    KARCHER_OPERATION_COUNTER_43:"Frost protection pump",
    KARCHER_OPERATION_COUNTER_44:"WSO filter inlay",
    KARCHER_OPERATION_COUNTER_45:"Washing station heater pump",
    KARCHER_OPERATION_COUNTER_46:"Hot water pump",
    KARCHER_OPERATION_COUNTER_47:"Foam hose heating",
    KARCHER_OPERATION_COUNTER_48:"Wheel cleaning pump",
    KARCHER_OPERATION_COUNTER_49:"Micro-emulsion pump",
    KARCHER_OPERATION_COUNTER_50:"Intensive foam pump",
    KARCHER_OPERATION_COUNTER_51:"Vacuum cleaner 1 turbine 1",
    KARCHER_OPERATION_COUNTER_52:"Vacuum cleaner 1 filter 1",
    KARCHER_OPERATION_COUNTER_53:"Vacuum cleaner 1 turbine 2",
    KARCHER_OPERATION_COUNTER_54:"Vacuum cleaner 1 filter 2",
    KARCHER_OPERATION_COUNTER_55:"Vacuum cleaner 2 turbine 1",
    KARCHER_OPERATION_COUNTER_56:"Vacuum cleaner 2 filter 1",
    KARCHER_OPERATION_COUNTER_57:"Vacuum cleaner 2 turbine 2",
    KARCHER_OPERATION_COUNTER_58:"Vacuum cleaner 2 filter 2",
    KARCHER_OPERATION_COUNTER_59:"Vacuum cleaner 3 turbine 1",
    KARCHER_OPERATION_COUNTER_60:"Vacuum cleaner 3 filter 1",
    KARCHER_OPERATION_COUNTER_61:"Vacuum cleaner 3 turbine 2",
    KARCHER_OPERATION_COUNTER_62:"Vacuum cleaner 3 filter 2",
    KARCHER_OPERATION_COUNTER_63:"Vacuum cleaner 4 turbine 1",
    KARCHER_OPERATION_COUNTER_64:"Vacuum cleaner 4 filter 1",
    KARCHER_OPERATION_COUNTER_65:"Vacuum cleaner 4 turbine 2",
    KARCHER_OPERATION_COUNTER_66:"Vacuum cleaner 4 filter 2",
    KARCHER_OPERATION_COUNTER_67:"Vacuum cleaner 5 turbine 1",
    KARCHER_OPERATION_COUNTER_68:"Vacuum cleaner 5 filter 1",
    KARCHER_OPERATION_COUNTER_69:"Vacuum cleaner 5 turbine 2",
    KARCHER_OPERATION_COUNTER_70:"Vacuum cleaner 5 filter 2",
    KARCHER_OPERATION_COUNTER_71:"Vacuum cleaner 6 turbine 1",
    KARCHER_OPERATION_COUNTER_72:"Vacuum cleaner 6 filter 1",
    KARCHER_OPERATION_COUNTER_73:"Vacuum cleaner 6 turbine 2",
    KARCHER_OPERATION_COUNTER_74:"Vacuum cleaner 6 filter 2",
    KARCHER_OPERATION_COUNTER_75:"Drain condensation water from the compressor",
    KARCHER_OPERATION_COUNTER_76:"Check frost protection system",
    KARCHER_OPERATION_COUNTER_77:"Burner fan",
    KARCHER_OPERATION_COUNTER_78:"Booster pump foam",
    DOWNLOAD_CSV_LARGE_DATA_WARNING:"Zoznam údajov obsahuje viac ako 10 000 položiek",
    KARCHER_POINT_NAME_1: "Sviatok",
    KARCHER_POINT_NAME_2: "Pondelok",
    KARCHER_POINT_NAME_3: "Utorok",
    KARCHER_POINT_NAME_4: "Streda",
    KARCHER_POINT_NAME_5: "Štvrtok",
    KARCHER_POINT_NAME_6: "Piatok",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Nedeľa",
    KARCHER_POINT_NAME_9: "Vysávače Sviatok",
    KARCHER_POINT_NAME_10: "Vysávače Pondelok",
    KARCHER_POINT_NAME_11: "Vysávače Utorok",
    KARCHER_POINT_NAME_12: "Vysávače Streda",
    KARCHER_POINT_NAME_13: "Vysávače Štvrtok",
    KARCHER_POINT_NAME_14: "Vysávače Piatok",
    KARCHER_POINT_NAME_15: "Vysávače Sobota",
    KARCHER_POINT_NAME_16: "Vysávače Nedeľa",
    KARCHER_POINT_NAME_17: "Osvetlenie Sviatok",
    KARCHER_POINT_NAME_18: "Osvetlenie Pondelok",
    KARCHER_POINT_NAME_19: "Osvetlenie Utorok",
    KARCHER_POINT_NAME_20: "Osvetlenie Streda",
    KARCHER_POINT_NAME_21: "Osvetlenie Štvrtok",
    KARCHER_POINT_NAME_22: "Osvetlenie Piatok",
    KARCHER_POINT_NAME_23: "Osvetlenie Sobota",
    KARCHER_POINT_NAME_24: "Osvetlenie Nedeľa",
    KARCHER_POINT_NAME_25:"Program 0",
    KARCHER_POINT_NAME_26:"Program 1",
    KARCHER_POINT_NAME_27:"Program 2",
    KARCHER_POINT_NAME_28:"Program 3",
    KARCHER_POINT_NAME_29:"Program 4",
    KARCHER_POINT_NAME_30:"Program 5",
    KARCHER_POINT_NAME_31:"Program 6",
    KARCHER_POINT_NAME_32:"Program 7",
    KARCHER_POINT_NAME_33:"Program 8",
    KARCHER_POINT_NAME_34:"Program 9",
    KARCHER_POINT_NAME_35:"Program 10",
    KARCHER_POINT_NAME_36:"Program 11",
    KARCHER_POINT_NAME_37:"Program 12",
    KARCHER_POINT_NAME_38:"Program 13",
    KARCHER_POINT_NAME_39:"Program 14",
    KARCHER_POINT_NAME_40:"Program 15",
    KARCHER_POINT_NAME_41:"Program 16",
    KARCHER_POINT_NAME_42:"Program 17",
    KARCHER_POINT_NAME_43:"Program 18",
    KARCHER_POINT_NAME_44:"Program 19",
    KARCHER_POINT_NAME_45:"Program 20",
    KARCHER_POINT_NAME_46:"Program 21",
    KARCHER_POINT_NAME_47:"Program 22",
    KARCHER_POINT_NAME_48:"Program 23",
    KARCHER_POINT_NAME_49:"Program 24",
    KARCHER_POINT_NAME_50:"Program 25",
    KARCHER_POINT_NAME_51:"Program 26",
    KARCHER_POINT_NAME_52:"Program 27",
    KARCHER_POINT_NAME_53:"Program 28",
    KARCHER_POINT_NAME_54:"Program 29",
    KARCHER_POINT_NAME_55:"Program 30",
    KARCHER_POINT_NAME_56:"Program 31",
    KARCHER_POINT_NAME_57:"Program 32",
    QR_CODE: "QR kód",
    ACCEPT_TERMS_AND_CONDITIONS: "Prijať podmienky používania",
    CREATE_AND_PRINT_VOUCHERS: "Vytvorte a vytlačte poukazy",
    CODE_PREFIX_QUESTION: "Predpona kódu nie je zadaná",
    CODE_PREFIX_QUESTION_TEXT: "Chcete pokračovať bez predpony kódu?",
    ISSUED_DATE: "Dátum vydania",
    VOUCHER_VALIDITY_DAYS: "Platnosť poukazu (dni)",
    VALIDATION_ONLY_NUMBERS: "Povolené sú iba čísla",
    REPRINT_VOUCHERS: "Vytlačiť kópiu poukazov",
    EXPIRY_DATE: "Platné do",
    VOUCHER_TYPE_VACUUM: "Poukaz na: Vysávač",
    VOUCHER_TYPE_JETWASH: "Poukaz na: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Poukaz na: Matt"
  });
})();
